import { FirmwareGetRequestParams } from "@lib/core";

export interface FirmwareDefaultParams extends FirmwareGetRequestParams { }
export class FirmwareDefaultParams {
  constructor() {
    this.select = "*";
    this.order = "id.asc";
  }
}